import React, { useRef } from 'react';
import ProductCard from './ProductCard';

const Productshome = ({ products = [], onAddToCart, onItemClick, cartList = [] }) => {
    const scrollRef = useRef(null);
    const isDragging = useRef(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);

    const scroll = (scrollOffset) => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({ left: scrollOffset, behavior: 'smooth' });
        }
    };

    const onMouseDown = (e) => {
        isDragging.current = true;
        startX.current = e.pageX - scrollRef.current.offsetLeft;
        scrollLeft.current = scrollRef.current.scrollLeft;
    };

    const onMouseLeave = () => {
        isDragging.current = false;
    };

    const onMouseUp = () => {
        isDragging.current = false;
    };

    const onMouseMove = (e) => {
        if (!isDragging.current) return;
        e.preventDefault();
        const x = e.pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX.current) * 1; //scroll-fast
        scrollRef.current.scrollLeft = scrollLeft.current - walk;
    };

    const onTouchStart = (e) => {
        isDragging.current = true;
        startX.current = e.touches[0].pageX - scrollRef.current.offsetLeft;
        scrollLeft.current = scrollRef.current.scrollLeft;
    };

    const onTouchEnd = () => {
        isDragging.current = false;
    };

    const onTouchMove = (e) => {
        if (!isDragging.current) return;
        const x = e.touches[0].pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX.current) * 1; //scroll-fast
        scrollRef.current.scrollLeft = scrollLeft.current - walk;
    };

    return (
        <section className="featured-products">
            <div  >
                <h2>Skincare products</h2>
                <p>Discover our latest Products </p>
            </div>

            <button
                onClick={() => scroll(-300)}
                className="scroll-button scroll-left"
                aria-label="Scroll Left"
            >
                <i className="fa fa-angle-left"></i>
            </button>

            <div
                ref={scrollRef}
                className="products-slider"
                onMouseDown={onMouseDown}
                onMouseLeave={onMouseLeave}
                onMouseUp={onMouseUp}
                onMouseMove={onMouseMove}
                onTouchStart={onTouchStart}
                onTouchEnd={onTouchEnd}
                onTouchMove={onTouchMove}
            >
                {products.map((product) => (
                    <div key={product.id} style={{ flex: '0 0 auto' }}>
                        <ProductCard
                            product={product}
                            onAddToCart={onAddToCart}
                            onItemClick={onItemClick}
                            cartList={cartList}
                        />
                    </div>
                ))}
            </div>

            <button
                onClick={() => scroll(300)}
                className="scroll-button scroll-right"
                aria-label="Scroll Right"
            >
                <i className="fa fa-angle-right"></i>
            </button>

            <style jsx>{`
                .featured-products {
                    position: relative;
                    padding: 60px 40px;
                    background-color: #fff;
                    margin: 5px 0;
                }

                @media (max-width: 768px) {
                    .featured-products {
                        padding: 20px 0;
                        margin: 0;
                    }

                    .products-slider {
                        padding: 20px 0;
                        gap: 10px;
                    }
                }

                @media (max-width: 480px) {
                    .featured-products {
                        padding: 20px 0;
                        margin: 0;
                    }

                    .products-slider {
                        padding: 20px 0;
                        gap: 10px;
                    }
                }

                .section-header {
                    text-align: center;
                    margin-bottom: 40px;
                }

                .section-header h2 {
                    font-size: 2.5rem;
                    font-weight: 700;
                    color: #2B2D42;
                    margin-bottom: 10px;
                }

                .section-header p {
                    font-size: 1.1rem;
                    color: #666;
                    max-width: 600px;
                    margin: 0 auto;
                }

                .products-slider {
                    display: flex;
                    flex-wrap: nowrap;
                    overflow-x: auto;
                    scroll-behavior: smooth;
                    padding: 20px 0;
                    gap: 5px;
                    cursor: grab;
                    scrollbar-width: none;
                    -ms-overflow-style: none;
                }

                .products-slider::-webkit-scrollbar {
                    display: none;
                }

                .scroll-button {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    background-color: #fff;
                    border: none;
                    color: #2B2D42;
                    font-size: 24px;
                    cursor: pointer;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                    transition: all 0.3s ease;
                    z-index: 2;
                }

                .scroll-button:hover {
                    background-color: #2B2D42;
                    color: #fff;
                }

                .scroll-left {
                    left: 10px;
                }

                .scroll-right {
                    right: 10px;
                }

                @media (max-width: 768px) {
                    .section-header h2 {
                        font-size: 2rem;
                    }

                    .scroll-button {
                        width: 35px;
                        height: 35px;
                        font-size: 20px;
                    }
                }
            `}</style>
        </section>
    );
};

export default Productshome;
